const customInputFile = () => {
    const inputList = document.querySelectorAll(".upload-file");

    inputList.forEach((input) => input.addEventListener("change", () => {
        const inputTag = input.querySelector("input");
        const helperText = input.querySelector(".form-item-info");
        const fileName = inputTag.files[0].name;

        if (fileName) {
            helperText.textContent = fileName;
        } else {
            helperText.textContent = "An error has occurred";
        }
    }));
};

export default customInputFile;



// WEBPACK FOOTER //
// ./assets/js/modules/custom-input-file.js